import { c as _c } from "react/compiler-runtime";
import { Body } from '@material-bank/mb3-components';
import { ChevronRight } from '@material-bank/mtag-icons';
import { formatImageSource } from '@material-bank/mtag-utilities';
const imageSize = 72;
type MaterialCardProps = {
  productName: string;
  variantSummary: string;
  imageUrl: string;
  // When provided, the card is an interactive button with a chevron affordance
  // and elevation. When omitted, it renders as a flat, informational card
  // (no chevron, no shadow) — e.g. inside the sign-in sheet.
  onPress?: () => void;
};
export function MaterialCard(t0) {
  const $ = _c(24);
  const {
    productName,
    variantSummary,
    imageUrl,
    onPress
  } = t0;
  let t1;
  if ($[0] !== imageUrl) {
    t1 = formatImageSource(imageUrl, imageSize, true);
    $[0] = imageUrl;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const imageSrc = t1;
  const isInteractive = onPress !== undefined;
  let t2;
  if ($[2] !== imageSrc || $[3] !== imageUrl || $[4] !== productName) {
    t2 = imageUrl ? <img alt={productName} {...imageSrc} width={imageSize} height={imageSize} className="rounded-[14px] border-2 border-white shadow-md object-cover flex-shrink-0 size-[72px]" /> : null;
    $[2] = imageSrc;
    $[3] = imageUrl;
    $[4] = productName;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== productName) {
    t3 = <Body variant="large" weight="semibold" className="text-foreground truncate">{productName}</Body>;
    $[6] = productName;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== variantSummary) {
    t4 = <Body variant="medium" className="text-muted-foreground truncate">{variantSummary}</Body>;
    $[8] = variantSummary;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3 || $[11] !== t4) {
    t5 = <div className="flex flex-col gap-0.5 flex-1 min-w-0">{t3}{t4}</div>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== isInteractive) {
    t6 = isInteractive ? <ChevronRight size={20} className="text-muted-foreground flex-shrink-0" /> : null;
    $[13] = isInteractive;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t2 || $[16] !== t5 || $[17] !== t6) {
    t7 = <>{t2}{t5}{t6}</>;
    $[15] = t2;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const content = t7;
  if (!isInteractive) {
    let t8;
    if ($[19] !== content) {
      t8 = <div className="flex items-center gap-4 w-full p-4 rounded-2xl border border-border bg-white text-left">{content}</div>;
      $[19] = content;
      $[20] = t8;
    } else {
      t8 = $[20];
    }
    return t8;
  }
  let t8;
  if ($[21] !== content || $[22] !== onPress) {
    t8 = <button type="button" className="flex items-center gap-4 w-full p-4 rounded-2xl border border-border bg-white text-left shadow-[0px_0px_20px_0px_rgba(0,0,0,0.08)]" data-haptic="light" onClick={onPress}>{content}</button>;
    $[21] = content;
    $[22] = onPress;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
}